import {Action} from '@ngrx/store';
import {GetCurrentUserSuccessAction} from '../actions/current-user/get-current-user-success-action';
import {LogoutSuccessAction} from '../actions/logout/logout-success-action';
import {Deserialize, Serialize} from 'cerialize';
import {GetCurrentUserErrorAction} from '../actions/current-user/get-current-user-error-action';
import {CurrentUserState} from '../states/current-user-state';
import {GetCurrentUserAction} from '../actions/current-user/get-current-user-action';
import {LogoutAction} from '../actions/logout/logout-action';
import {LogoutErrorAction} from '../actions/logout/logout-error-action';

const initialState = new CurrentUserState();

export function CurrentUserReducer(serializedState: any = Serialize(initialState), action: Action): any {
  const state: CurrentUserState = Deserialize(serializedState, CurrentUserState);

  switch (action.type) {
    case GetCurrentUserAction.type:
      state.ready = false;
      state.error = null;
      break;

    case GetCurrentUserSuccessAction.type:
      state.ready = true;
      state.user = (<GetCurrentUserSuccessAction>action).user;
      state.error = null;
      break;

    case GetCurrentUserErrorAction.type:
      state.ready = true;
      state.user = null;
      state.error = (<GetCurrentUserErrorAction>action).error;
      break;

    case LogoutAction.type:
      state.ready = false;
      state.error = null;
      break;

    case LogoutSuccessAction.type:
      state.ready = true;
      state.user = null;
      state.error = null;
      break;

    case LogoutErrorAction.type:
      state.ready = true;
      state.error = (<LogoutErrorAction>action).error;
      break;

    default:
      return serializedState;
  }

  return Serialize(state);
}
